module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-16.6e24d25f.png";